<template>
  <div
    class="card"
    v-if="
      whitelabelHasRightsToArchiveCustomer ||
      webshipperStaffHasRightsToArchiveCustomer
    "
  >
    <div class="card-body">
      <h4>{{ $t("archive_customer") }}</h4>
      <hr />
      <div class="row">
        <div class="col-md-4">
          <p class="text-muted">{{ infoMessage }}</p>
        </div>
        <div class="col-md-8">
          <div class="form-group">
            <button
              class="btn btn-danger"
              @click="
                confirmModal(
                  $event,
                  $t('are_you_sure'),
                  confirmModalMessage,
                  archiveCustomer
                )
              "
            >
              {{ $t("archive") }}
            </button>
            <br />
            <strong v-if="customer.archived_at">{{
              $t("customer_is_archived")
            }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customer: {
      type: Object,
      required: true,
    },
    thirdPartyManaged: {
      type: Boolean,
    },
  },
  computed: {
    whitelabelHasRightsToArchiveCustomer() {
      const { organization: selectedOrg } = this.customer || {};
      const { id: loggedInOrgId } = this.currentOrganization || {};
      return (
        this.can("write_customers") &&
        selectedOrg?.id === loggedInOrgId &&
        this.thirdPartyManaged
      );
    },
    webshipperStaffHasRightsToArchiveCustomer() {
      return !this.thirdPartyManaged && this.can("write_developer_actions");
    },
    infoMessage() {
      return this.$t(
        this.webshipperStaffHasRightsToArchiveCustomer
          ? "archive_customers_information_third_party"
          : "archive_customers_information_whitelabel"
      );
    },
    confirmModalMessage() {
      return this.$t(
        this.webshipperStaffHasRightsToArchiveCustomer
          ? "archive_customer_modal_warning"
          : "archive_customer_modal_warning_whitelabel"
      );
    },
  },
  methods: {
    archiveCustomer() {
      this.$emit("archiveCustomer");
    },
  },
};
</script>